/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Faq_Q1Inputs */

const en_pc_dl_faq_q1 = /** @type {(inputs: Pc_Dl_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Which Windows file should I download?`)
};

const zh_pc_dl_faq_q1 = /** @type {(inputs: Pc_Dl_Faq_Q1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Windows 应该下载哪个文件？`)
};

/**
* | output |
* | --- |
* | "Which Windows file should I download?" |
*
* @param {Pc_Dl_Faq_Q1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_faq_q1 = /** @type {((inputs?: Pc_Dl_Faq_Q1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Faq_Q1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_faq_q1(inputs)
	return zh_pc_dl_faq_q1(inputs)
});
export { pc_dl_faq_q1 as "pc.dl.faq.q1" }